// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"732":"3ec4e98d5f649457a3ba","983":"20d380040ed7071d9978"}[chunkId] + ".js";
};